import { createContext, useContext } from 'react'

export const LeavePreventionContext = createContext<{
  hideLeavePreventionModal: () => void
  showLeavePreventionModal: () => void
}>(undefined)
LeavePreventionContext.displayName = 'LeavePreventionContext'

export const useLeavePreventionContext = () =>
  useContext(LeavePreventionContext)
